import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';
import { OffsetBox } from '../../other/offsetBox.model';

export class DockingBehaviourComponent extends BaseComponent {
    constructor(){
        super();
        this.componentType = ComponentNames.dockingBehaviorComponent;
    }
    offsetBox:OffsetBox;
    mustDock:Array<BaseComponent>;
    mustNotDock:Array<BaseComponent>;
}